import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Home, Shield, AlertTriangle, Building2, ThermometerSnowflake, Wrench } from 'lucide-react';

const Services = () => {
  const services = [
    {
      icon: Home,
      title: 'Ravalement de façade',
      description: 'Ravalement complet pour maisons, immeubles et copropriétés : diagnostic, traitement du support et finition adaptée au bâti.',
    },
    {
      icon: AlertTriangle,
      title: 'Traitement des fissures',
      description: 'Diagnostic des pathologies et réparation durable des fissures, avec systèmes armés et pontage selon les règles de l\'art.',
    },
    {
      icon: Building2,
      title: 'Ravalement pierre & chaux',
      description: 'Ravalement traditionnel pierre de taille et enduit à la chaux pour immeubles haussmanniens : matériaux respirants et durables.',
    },
    {
      icon: ThermometerSnowflake,
      title: 'Isolation par l\'extérieur (ITE)',
      description: 'Isolation thermique par l\'extérieur, y compris isolants biosourcés (fibre de bois, liège), pour le confort et la performance.',
    },
    {
      icon: Wrench,
      title: 'Corniches & modénatures',
      description: 'Restauration des éléments architecturaux : corniches, balcons, garde-corps et ornements de façade.',
    },
    {
      icon: Shield,
      title: 'Nettoyage & protection',
      description: 'Nettoyage, hydrofuge et traitements de protection pour préserver et valoriser durablement vos façades.',
    },
  ];

  return (
    <section id="facade" className="py-24 bg-slate-50 scroll-mt-28">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="max-w-3xl mb-14">
          <span className="text-emerald-600 font-semibold text-sm uppercase tracking-wider mb-3 block">
            Façade &amp; Isolation
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-5">
            Ravalement, façade et isolation par l'extérieur
          </h2>
          <p className="text-lg md:text-xl text-slate-600 leading-relaxed">
            Protéger, isoler et embellir le bâti : VIREO réalise le ravalement, le traitement des
            fissures et l'isolation par l'extérieur pour maisons, immeubles et copropriétés.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {services.map((service, index) => {
            const IconComponent = service.icon;
            return (
              <Card
                key={index}
                data-testid={`facade-service-${index}`}
                className="group hover:shadow-xl transition-all duration-300 border-slate-200 hover:border-emerald-500 hover:-translate-y-1.5 bg-white"
              >
                <CardHeader>
                  <div className="w-14 h-14 bg-emerald-100 rounded-xl flex items-center justify-center mb-4 group-hover:bg-emerald-600 transition-colors duration-300">
                    <IconComponent className="h-7 w-7 text-emerald-600 group-hover:text-white transition-colors duration-300" />
                  </div>
                  <CardTitle className="text-xl text-slate-900 group-hover:text-emerald-600 transition-colors">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-slate-600 leading-relaxed">{service.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* CTA Section */}
        <div className="bg-gradient-to-br from-slate-800 to-slate-900 rounded-2xl p-8 md:p-12 text-center relative overflow-hidden">
          <div className="absolute top-0 right-0 w-64 h-64 bg-emerald-600/10 rounded-full blur-3xl"></div>
          <div className="relative z-10">
            <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Un projet de façade ou d'isolation ?
            </h3>
            <p className="text-xl text-slate-300 mb-8">
              Nous établissons un diagnostic et un devis détaillé, gratuitement.
            </p>
            <button
              onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
              data-testid="facade-cta"
              className="bg-gradient-to-r from-emerald-600 to-cyan-600 hover:from-emerald-700 hover:to-cyan-700 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300 hover:scale-105 shadow-lg"
            >
              Demander une étude gratuite
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
